import React from "react";
import Heading from "./Heading";
import { fryer } from "./fryersData";
function Fryers() {
  return (
    <>
      <a href="#" id="fryers"></a>
      <div className="w-full p-4 h-fit font-fancy">
        <Heading heading="Fryers" />
        {fryer.map((fryer) => {
          return (
            <React.Fragment key={fryer.id}>
              <div className="p-4 my-5 shadow-2xl shadow-gray-700 drop-shadow-xl rounded-2xl ">
                <h3 className="text-lg font-bold">{fryer.name}</h3>
                <div className="flex gap-16">
                  <div className="[&>*:nth-child(even)]:rounded-r-full [&>*:nth-child(even)]:bg-gradient-to-tr [&>*:nth-child(even)]:from-yellow-200 [&>*:nth-child(even)]:to-yellow-500 [&>*:nth-child(even)]:font-extrabold [&>*:nth-child(even)]:px-2">
                    <p>{fryer["6Pcs"]}</p>
                    <p>{fryer["6pcsPrice"]}</p>
                    <p>{fryer.singlepc}</p>
                    <p>{fryer.singlePcPrice}</p>
                    <p>{fryer["20pcs"]}</p>
                    <p>{fryer["20pcsPrice"]}</p>
                  </div>
                  <div className="[&>*:nth-child(even)]:rounded-r-full [&>*:nth-child(even)]:bg-gradient-to-tr [&>*:nth-child(even)]:from-yellow-200 [&>*:nth-child(even)]:to-yellow-500 [&>*:nth-child(even)]:font-extrabold [&>*:nth-child(even)]:px-2">
                    <p>{fryer["12pcs"]}</p>
                    <p>{fryer["12pcsPrice"]}</p>
                    <p>{fryer["5pcs"]}</p>
                    <p>{fryer["5pcsPrice"]}</p>
                    <p></p>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
}

export default Fryers;
